import React, { useEffect } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { Button, Icon } from 'semantic-ui-react';
import Image from '@tiptap/extension-image'
// import './TiptapEditor.css'; // optional CSS for styling

const MenuBar = ({ editor }) => {
  if (!editor) return null

  const getActive = (name, attrs = {}) =>
    editor.isActive(name, attrs) ? 'blue' : 'grey'

  const insertImage = () => {
    const url = window.prompt('Enter image URL:')
    if (url) {
      editor.chain().focus().setImage({ src: url }).run()
    }
  }

  const button = (key, iconName, action, options) => <Button
    size='mini'
    icon
    color={getActive(key)}
    title={key}
    onClick={() => {
      // Handle commands that may need parameters (like heading levels)
      const chain = editor.chain().focus()
      if (typeof chain[action] === 'function') {
        chain[action](options).run()
      } else {
        console.warn(`Unknown editor action: ${action}`)
      }
    }}
  >
    <Icon name={iconName} />
  </Button>

  return (
    <div style={{ marginBottom: '0.75rem', display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
      {/* Text Styles */}
      {button('bold', 'bold', 'toggleBold')}
      {button('italic', 'italic', 'toggleItalic')}
      {button('strike', 'strikethrough', 'toggleStrike')}
      {button('code', 'code', 'toggleCode')}

      {/* Headings */}
      {/* {button('heading', 'header', 'toggleHeading', { level: 1 })}
      {button('heading', 'header', 'toggleHeading', { level: 2 })}
      {button('heading', 'header', 'toggleHeading', { level: 3 })} */}

      {/* Blocks */}
      {button('paragraph', 'paragraph', 'setParagraph')}
      {button('blockquote', 'quote right', 'toggleBlockquote')}
      {button('codeBlock', 'file code', 'toggleCodeBlock')}

      {/* Lists */}
      {button('bulletList', 'list ul', 'toggleBulletList')}
      {button('orderedList', 'list ol', 'toggleOrderedList')}

      {/* Insert */}
      {button('minus', 'minus', 'setHorizontalRule')}
      {button('level', 'level down alternate', 'setHardBreak')}

      {/* Clear / Reset */}
      {button('eraser', 'eraser', 'unsetAllMarks')}
      {button('trash', 'trash', 'clearNodes')}

      {/* Undo / Redo */}
      {button('undo', 'undo', 'undo')}
      {button('redo', 'redo', 'redo')}
      <Button size='mini' icon color='grey' onClick={insertImage}>
        <Icon name='image' />
      </Button>
    </div >
  )
}


const TiptapEditor = ({ htmlValue, handleEditorChange }) => {
  const editor = useEditor({
    extensions: [
      StarterKit,
      Image, // add this
    ],
    content: htmlValue || '',
    onUpdate: ({ editor }) => {
      handleEditorChange(editor.getHTML());
    },
  });

  // Keep editor in sync if htmlValue changes externally
  useEffect(() => {
    if (editor && htmlValue !== editor.getHTML()) {
      editor.commands.setContent(htmlValue || '');
    }
  }, [htmlValue, editor]);

  return (
    <div className="html-editor-container">
      <MenuBar editor={editor} />
      <div
        className="tiptap-editor"
        style={{
          minHeight: '150px',
          cursor: 'text',
        }}
      >
        <EditorContent editor={editor} style={{ border: '0px' }} />
      </div>
    </div>
  )
};

export default TiptapEditor;
